export const transition = "all 0.2s ease";
